import { useNavigate } from "react-router-dom";
import { FaCaretLeft } from "react-icons/fa";
import { IoIosArrowBack } from "react-icons/io";
import { FaLock } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import { FaChevronUp } from "react-icons/fa";
import { useState, useEffect } from "react";
import Header from "../Header.js";
import useUser from "../../hook/useUser"
import api from "../../api/axios";

const PositionalTraining = () => {
    const navigate = useNavigate();
    const { user } = useUser();
    const [training, setTraining] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    
    useEffect(() => {
      if (!user || !user.employeeId) return;
      
      const fetchTraining = async () => {
        try {
                    const response = await api.get(`/api/employee/${user.employeeId}/training`);
                    setTraining(response.data);
        } catch(err) {
          console.error(err);
        }
      };
      fetchTraining();
    }, [user]);

        return (
        <>
            <div className="dashboard-wrapper">
                <Header />
                {/* dashboardに戻る */}
                <div onClick={() => navigate('/dashboard')} style={{ cursor: "pointer" }} className="nav_title">
                    <IoIosArrowBack className="fa-chevron-left"/>
                    Your Progress
                </div>

                <div className="card">
                    <div className="card-header" onClick={() => setIsOpen(!isOpen)} tyle={{ cursor: "pointer" }}>
                        <h2>{user ? user.modules.positionTraining.serverBasicSkills?.title : "Loading..."}</h2>
                        {/* <FaChevronDown className="fa-chevron-down"/> */}
                        {isOpen ? (
                            <FaChevronUp className="fa-chevron-up" />
                            ) : (
                            <FaChevronDown className="fa-chevron-down" />
                        )}
                </div>
                {isOpen && (
                <div className="items" id="items">
                    <h3 className="item" onClick={() => navigate("/dashboard/general-training/pre-job-preparation")}
                    style={{ cursor: "pointer" }}>
                        {user ? user.modules.positionTraining.serverBasicSkills.customerServiceSkills?.title : "Loading..."}
                    </h3>
                    <h3 className="item" onClick={() => navigate("/dashboard/general-training/pre-job-preparation")}
                    style={{ cursor: "pointer" }}>
                        {user ? user.modules.positionTraining.serverBasicSkills.orderPaymentHandling?.title : "Loading..."}
                    </h3>
                    <h3 className="item" onClick={() => navigate("/dashboard/general-training/pre-job-preparation")}
                    style={{ cursor: "pointer" }}>
                        {user ? user.modules.positionTraining.serverBasicSkills.teamworkCommunication?.title : "Loading..."}
                    </h3>
                    <h3 className="item" onClick={() => navigate("/dashboard/general-training/pre-job-preparation")}
                    style={{ cursor: "pointer" }}>
                        {user ? user.modules.positionTraining.serverBasicSkills.organizationCompliance?.title : "Loading..."}
                    </h3>
                </div>
                )}
            </div>

            <div className="card-text-only">
                <h2>{user ? user.modules.positionTraining.bartenderSkills?.title : "Loading..."}</h2>
                <FaLock className="fa-lock"/>
            </div>
            <div className="card-text-only">
                <h2>{user ? user.modules.positionTraining.drinkRecipe?.title : "Loading..."}</h2>
                <FaLock className="fa-lock"/>
            </div>
                
                
            </div>
        </>
    );
}

export default PositionalTraining;